'use client';
import { useEffect, useState } from 'react';
import { getLocalizedName, assembleName } from '@/lib/nameTranslations';

export default function LocalizedName({ user, initial }) {
    const [display, setDisplay] = useState(initial ?? assembleName(user));

    useEffect(() => {
        try {
            const localized = getLocalizedName(user);
            if (localized) setDisplay(localized);
        } catch (err) {
            console.warn('LocalizedName failed', err);
        }
    }, [user]);

    return <>{display}</>;
}
